import { i18next } from '@yola/ws-sdk';
import elementSettings from 'src/js/modules/element-settings';
import preloadImage from 'src/js/modules/utils/preload-image';
import ColumnAppearanceSettingsContainer from '../containers/column-appearance-settings-container';
import getColumnElementType from '../helpers/get-column-element-type';
import { columnPreviewGifs } from '../constants/preview-gifs';
import settingIds from '../constants/setting-ids';

const {
  constants: { triggerTypes },
} = elementSettings;

const getThisColumnSettings = () => {
  Object.values(columnPreviewGifs).forEach((gif) => preloadImage(gif));

  return {
    id: settingIds.THIS_COLUMN,
    triggerOn: triggerTypes.HOVER,
    priority: 2,
    matches(element, config) {
      return element.matches(config.querySelector) && element.closest(config.parentSelector);
    },
    getTargetElementType(element, config) {
      return getColumnElementType(element);
    },
    settings: {
      parentSelector: 'ws-block[custom]',
      querySelector: 'ws-column',
    },
    tabs: [
      {
        id: 'appearance',
        accordionTitle: i18next.t('This column'),
        component: ColumnAppearanceSettingsContainer,
      },
    ],
  };
};

export default getThisColumnSettings;
